import { z } from "zod";

export const ImprovePromptRequest = z.object({
  surface: z.enum(["word_addin", "web"]),
  organisation: z.string(),
  draft: z.string().min(1),
  open_document: z.string().nullish(),
  selected_text: z.string().nullish(),
  attachments: z.array(z.string()).default([]),
  selected_playbook: z.string().nullish(),
  selected_skills: z.array(z.string()).default([]),
  improved: z.string().nullish(),
  answers: z.string().nullish(),
});
export type ImprovePromptRequest = z.infer<typeof ImprovePromptRequest>;

export const ImprovePromptResult = z.object({
  improved_prompt: z.string(),
  nudge: z.string().nullable(),
  trace_id: z.string().nullish(),
});
export type ImprovePromptResult = z.infer<typeof ImprovePromptResult>;

export const PROMPT_IMPROVE_CLICKED_EVENT = "prompt_improve_clicked";
export const PROMPT_IMPROVED_EVENT = "prompt_improved";
